import { render, staticRenderFns } from "./PalletInCalifornianDetail.vue?vue&type=template&id=72ce3aae"
import script from "./PalletInCalifornianDetail.vue?vue&type=script&lang=js"
export * from "./PalletInCalifornianDetail.vue?vue&type=script&lang=js"
import style0 from "./PalletInCalifornianDetail.vue?vue&type=style&index=0&id=72ce3aae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports